import { render, staticRenderFns } from "./DetailModal.vue?vue&type=template&id=1aa310a5&scoped=true&"
import script from "./DetailModal.vue?vue&type=script&lang=js&"
export * from "./DetailModal.vue?vue&type=script&lang=js&"
import style0 from "./DetailModal.vue?vue&type=style&index=0&id=1aa310a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa310a5",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CharacterCount: require('/app/appsumo/nuxt/components/common/CharacterCount.vue').default,Button: require('/app/appsumo/nuxt/components/wishlists/Button.vue').default,Modal: require('/app/appsumo/nuxt/components/common/Modal.vue').default,DeleteModal: require('/app/appsumo/nuxt/components/wishlists/DeleteModal.vue').default})
